import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const sheeridFormRedirectEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map